import React, { createContext, useContext, useRef } from "react";

const MemoCacheContext = createContext<Record<string, unknown> | null>(null);

interface MemoCacheProviderProps {
  children: React.ReactNode;
}

export function MemoCacheProvider({ children }: MemoCacheProviderProps) {
  const cacheRef = useRef<Record<string, unknown>>({});
  return (
    <MemoCacheContext.Provider value={cacheRef.current}>
      {children}
    </MemoCacheContext.Provider>
  );
}

export function useAppMemoCache<T extends Record<string, () => unknown>>(memoMap: T): { [K in keyof T]: ReturnType<T[K]> } {
  const cache = useContext(MemoCacheContext);
  if (!cache) throw new Error("useAppMemoCache must be used within a MemoCacheProvider");
  const result = {} as { [K in keyof T]: ReturnType<T[K]> };
  for (const id in memoMap) {
    if (!cache[id]) {
      cache[id] = memoMap[id]();
    }
    result[id as keyof T] = cache[id] as ReturnType<T[typeof id]>;
  }
  return result;
}
